export default {
    type: '', // pageType (create/edit/detail)
    userDetail: {
        userId: '',
        name: '',
        password: '',
        hubId: '',
        level: '',
        telephone: '',
        memo: '',
        useYn: '',
        resignationAt: '',
    },
    hubList: [],
};
